import { store } from '@/decorators/store';
import { Shift } from '@/entities/Shift';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'ShiftStore' })
export class ShiftStore extends AbstractEntityStore<Shift> {
  protected entityIdKey = 'id';
  protected entityValueKey = 'name';
}
